<main class="content">
  <section class="card">
    <div class="card-head">
      <div>
        <h2>Postulaciones para patrocinio</h2>
        <p class="subtitle">Gestiona la decision institucional y descarga el historial filtrado para analisis externo.</p>
      </div>
    </div>

    <div class="filtros">
      <div class="filtros-top">
        <input type="text" placeholder="Buscar por concurso, ID, folio o proyecto" [(ngModel)]="busqueda" />
        <button type="button" class="btn-top btn-search" (click)="ejecutarBusqueda()">Buscar</button>
        <button type="button" class="btn-top btn-clear" (click)="limpiarBusquedaYFiltros()">Limpiar</button>
      </div>

      <div class="filtros-bottom">
        <select [(ngModel)]="idPostulacionSeleccionado">
          <option value="Todos">Todos los ID de postulacion</option>
          <option *ngFor="let item of idsPostulacion" [value]="item">{{ item }}</option>
        </select>
        <select [(ngModel)]="folioSeleccionado">
          <option value="Todos">Todos los folios</option>
          <option *ngFor="let item of folios" [value]="item">{{ item }}</option>
        </select>
        <select [(ngModel)]="subdireccionSeleccionada">
          <option value="Todas">Todas las subdirecciones</option>
          <option *ngFor="let item of subdirecciones" [value]="item">{{ item }}</option>
        </select>
        <select [(ngModel)]="estadoSeleccionado">
          <option value="Todos">Todos los estados</option>
          <option *ngFor="let item of estados" [value]="item">{{ item }}</option>
        </select>
      </div>
    </div>

    <p class="mensaje mensaje-warning" *ngIf="mensajeBusqueda">{{ mensajeBusqueda }}</p>

    <div class="table-wrap" *ngIf="postulacionesFiltradas.length > 0; else sinResultadosPatrocinioTpl">
      <table class="table">
        <thead>
          <tr>
            <th>ID Postulacion</th>
            <th>Concurso</th>
            <th>Titulo Proyecto</th>
            <th>Folio</th>
            <th>Subdireccion</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of postulacionesPaginadas">
            <td>{{ item.idPostulacion }}</td>
            <td>{{ item.concurso }}</td>
            <td>{{ item.nombreProyecto }}</td>
            <td>{{ item.folio }}</td>
            <td>{{ item.subdireccion }}</td>
            <td>
              <span class="estado-chip">{{ etiquetaEstado(item) }}</span>
            </td>
            <td class="actions">
              <ng-container *ngIf="esAyudanteRepresentante; else accionesRepresentanteTpl">
                <span class="action-note">Solo seguimiento</span>
              </ng-container>
              <ng-template #accionesRepresentanteTpl>
                <ng-container *ngIf="tieneFirmaRegistrada(item); else responderTpl">
                  <span class="action-note">Firma registrada</span>
                </ng-container>
              </ng-template>
              <ng-template #responderTpl>
                <button type="button" class="btn-mini btn-view btn-respond" (click)="abrirModalResponder(item)">Responder</button>
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #sinResultadosPatrocinioTpl>
      <app-empty-filter-state title="No se han encontrado postulaciones" message="Ajusta los filtros aplicados o limpia la búsqueda para volver a intentarlo."></app-empty-filter-state>
    </ng-template>

    <div class="table-actions">
      <button type="button" class="btn-top btn-export" (click)="descargarHistorial()">Descargar Excel</button>
    </div>

    <app-table-pagination
      [page]="paginaActual"
      [pageSize]="cantidadPorPagina"
      [totalItems]="postulacionesFiltradas.length"
      itemLabel="postulaciones"
      [pageSizeOptions]="opcionesCantidad"
      (pageChange)="cambiarPagina($event)"
      (pageSizeChange)="cambiarCantidadDesdePaginador($event)"
    ></app-table-pagination>

    <p class="mensaje" *ngIf="mensaje">{{ mensaje }}</p>
  </section>
</main>

<div class="modal-backdrop" *ngIf="modalResponderVisible">
  <div class="modal-card" role="dialog" aria-modal="true" aria-label="Responder solicitud de patrocinio">
    <ng-container *ngIf="postulacionResponder as item">
      <h3>Responder solicitud de patrocinio</h3>
      <p class="modal-lead">Selecciona la accion institucional para esta postulacion.</p>

      <div class="decision-summary">
        <div><strong>ID Postulacion:</strong> {{ item.idPostulacion }}</div>
        <div><strong>Concurso:</strong> {{ item.concurso }}</div>
        <div><strong>Titulo Proyecto:</strong> {{ item.nombreProyecto }}</div>
        <div><strong>Estado:</strong> {{ etiquetaEstado(item) }}</div>
      </div>

      <div class="modal-actions modal-actions-stack">
        <button type="button" class="btn-top btn-sign" (click)="firmarDesdeRespuesta()">Firmar patrocinio</button>
        <button type="button" class="btn-top btn-view" (click)="observarDesdeRespuesta()">Observar</button>
        <button type="button" class="btn-top btn-no" (click)="rechazarDesdeRespuesta()">Rechazar</button>
        <button type="button" class="btn-top btn-clear" (click)="cerrarModalResponder()">Cancelar</button>
      </div>
    </ng-container>
  </div>
</div>

<div class="modal-backdrop" *ngIf="modalDecisionVisible">
  <div class="modal-card" role="dialog" aria-modal="true" [attr.aria-label]="tituloModalDecision">
    <h3>{{ tituloModalDecision }}</h3>
    <p class="modal-lead">
      <ng-container *ngIf="decisionPendiente === 'observada'; else rechazoTexto">
        Ingresa una observacion para devolver la postulacion al postulante y permitir su correccion.
      </ng-container>
      <ng-template #rechazoTexto>
        Ingresa un comentario para rechazar la postulacion. Una vez rechazada, quedara bloqueada para edicion.
      </ng-template>
    </p>

    <div class="decision-summary" *ngIf="postulacionDecision as item">
      <div><strong>ID Postulacion:</strong> {{ item.idPostulacion }}</div>
      <div><strong>Concurso:</strong> {{ item.concurso }}</div>
      <div><strong>Titulo Proyecto:</strong> {{ item.nombreProyecto }}</div>
      <div><strong>Folio:</strong> {{ item.folio }}</div>
    </div>

    <label class="textarea-label" for="comentarioDecision">Comentario</label>
    <textarea
      id="comentarioDecision"
      class="decision-textarea"
      rows="7"
      [(ngModel)]="comentarioDecision"
      [placeholder]="placeholderComentarioDecision"
    ></textarea>

    <div class="decision-meta">
      <span>{{ palabrasComentarioDecision }} / 5000 palabras</span>
    </div>

    <p class="mensaje mensaje-warning" *ngIf="mensajeDecision">{{ mensajeDecision }}</p>

    <div class="modal-actions">
      <button type="button" class="btn-top btn-clear" (click)="cerrarModalDecision()">Cancelar</button>
      <button type="button" class="btn-top" [ngClass]="decisionPendiente === 'rechazada' ? 'btn-no' : 'btn-view'" (click)="confirmarDecisionConComentario()">
        {{ etiquetaBotonDecision }}
      </button>
    </div>
  </div>
</div>
